import { FormControl, FormHelperText } from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { ICustomField } from "@ryde/shared";

import { RecurringProductionLogic } from "./recurring-production.logic";
import { RecurringProductionStyled } from "./recurring-production.styled";

export const RecurringProductionTemplate: FC<ICustomField> = props => {
  const { control } = useFormContext();

  return (
    <RecurringProductionStyled>
      <Controller
        name={props.name}
        control={control}
        render={({ fieldState: { error } }) => {
          return (
            <FormControl
              error={!!error}
              data-e2e-template="recurring-production-template"
            >
              <RecurringProductionLogic {...props} />
              {error && <FormHelperText>{error.message}</FormHelperText>}
            </FormControl>
          );
        }}
      />
    </RecurringProductionStyled>
  );
};
